module.exports = __webpack_public_path__ + "img/straight.bd20a0b8.png";